<template>
    <div class="has-background-black">
            <div class="container">
                <div>
                    <br>
                    <div class="top80 has-text-light has-text-centered">
                        
                        <div class=" top60 marginAutod">
                            <img src="@/assets/img/Miimu logo.png" width="290"/>
                        </div>

                        <div class="has-text-weight-bold top20">
                            <span class="footerLink" @click="$router.push('/info')">About</span> | <span class="footerLink" @click="$router.push('/info/help')">Help</span> | <span class="footerLink" @click="$router.push('/info/faq')">FAQ</span> | <span class="footerLink"  @click="$router.push('/info/contact')">Contact</span>
                        </div>

                        <div class="top20">
                            <a href="https://www.facebook.com/miimu.official/" target="_blank"><img src="@/assets/img/facebookIcon.png" /></a>
                            <a href="https://www.instagram.com/miimu.official/" target="_blank"><img src="@/assets/img/instagramIcon.png" width="26" class="instaIconAdjust" /></a>
                            <a href="https://x.com/miimu.official" target="_blank"><img src="@/assets/img/twitterIcon.png" /></a>
                            <a href="https://www.youtube.com/@miimu.official" target="_blank"><img src="@/assets/img/youtubeIcon.png" /></a>
                        </div>

                        <div class="has-text-grey is-size-6 top40">
                            @ 2024 Miimu, LLC
                        </div>
                    </div>
                </div>
                <div class="top80">&nbsp;</div>
            </div>
        </div>
</template>

<script>



export default {
    name: 'footerdiv',
}


</script>